export default {
    'POPUP.FINALY.TITLE': 'Bravo !',
    'POPUP.FINALY.ASIDE': 'Votre nouveau mot de passe est maintenant configuré',
    'POPUP.FINALY.CLOSE': 'Fermer',
    'POPUP.FINALY.EVENT.DELETED': 'Événement supprimé',
    'POPUP.FINALY.EVENT.DELETED.TEXT': 'a été supprimé',
};
